import {
  getSegmentedIconClassName,
  getSegmentedOptionClassName,
  getSegmentedTrackClassName,
} from '@/components/ui/atoms/SegmentedButton';

/** SegmentedButton variant shared by the stage tabs and the "More" segment. */
export const STATUS_TABS_SEGMENT = {
  size: 'md',
  appearance: 'filled',
  intent: 'info',
  rounded: 'full',
} as const;

const { size, appearance, intent, rounded } = STATUS_TABS_SEGMENT;

/** One track around the visible tabs and "More", so both read as one control. */
export const STATUS_TABS_TRACK_CLASS = getSegmentedTrackClassName(
  size,
  rounded,
  false,
  appearance,
  intent,
  'shrink-0',
);

/** Inactive segment look for the "More" trigger. */
export const STATUS_TABS_MORE_CLASS = getSegmentedOptionClassName(
  size,
  rounded,
  appearance,
  intent,
  false,
  false,
  false,
  true,
);

export const STATUS_TABS_ICON_CLASS = getSegmentedIconClassName(size);
